import { CloseOutlined, FilterOutlined } from '@ant-design/icons';
import { Button, InputNumber, Space, Typography } from 'antd';
import React, { useState } from 'react';

import { LocationAutocomplete } from '../../components/LocationAutocomplete/LocationAutocomplete';

import { LocationRadiusMap } from './components/LocationRadiusMap';

const { Text } = Typography;

interface LocationFilterProps {
  filterLocation: string;
  filterRadius: number;
  onLocationChange: (location: string, coordinates?: { lat: number; lng: number }) => void;
  onRadiusChange: (radius: number) => void;
  onClear: () => void;
}

export const LocationFilter: React.FC<LocationFilterProps> = ({
  filterLocation,
  filterRadius,
  onLocationChange,
  onRadiusChange,
  onClear,
}) => {
  const [coordinates, setCoordinates] = useState<{ lat: number; lng: number } | undefined>();

  const handleLocationChange = (location: string, coords?: { lat: number; lng: number }) => {
    setCoordinates(coords);
    onLocationChange(location, coords);
  };

  return (
    <div className="bg-white p-4 rounded-lg border border-gray-200 mb-6">
      <div className="flex items-center gap-2 mb-4">
        <FilterOutlined className="text-gray-400" style={{ fontSize: '16px' }} />
        <Text className="text-gray-700 font-medium">Wybierz obszar</Text>
      </div>

      <Space direction="vertical" size={16} className="w-full">
        <div className="flex gap-4 items-end">
          <div className="flex-1">
            <Text className="block mb-2">Lokalizacja</Text>
            <LocationAutocomplete
              value={filterLocation}
              onChange={handleLocationChange}
              placeholder="Wpisz lokalizację do filtrowania"
              size="middle"
            />
          </div>
          {filterLocation && (
            <div>
              <Text className="block mb-2">Promień</Text>
              <InputNumber
                value={filterRadius}
                onChange={(value) => value && onRadiusChange(value)}
                min={1}
                max={200}
                addonAfter="km"
                style={{ width: 120 }}
              />
            </div>
          )}
        </div>

        {filterLocation && coordinates && (
          <>
            <LocationRadiusMap center={coordinates} radius={filterRadius} />

            <Button
              icon={<CloseOutlined />}
              onClick={onClear}
              type="text"
              className="text-gray-500 hover:text-gray-700"
              size="small">
              Wyczyść
            </Button>
          </>
        )}
      </Space>
    </div>
  );
};
